import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { InlineEditable } from '@integration-app/react';
import clsx from 'clsx';
import classes from './Field.module.css';
export function FieldKeyEditable({ value, onChange, deprecatedNames = [], ...props }) {
    const [isInvalid, setIsInvalid] = useState(false);
    const [localValue, setLocalValue] = useState(value);
    const [dirtyInput, setDirtyInput] = useState(false);
    useEffect(() => {
        if (!dirtyInput) {
            setLocalValue(value);
        }
    }, [value, dirtyInput]);
    function handleChange(name) {
        setLocalValue(name);
        setDirtyInput(true);
        if (deprecatedNames === null || deprecatedNames === void 0 ? void 0 : deprecatedNames.includes(name)) {
            setIsInvalid(true);
            return;
        }
        setIsInvalid(false);
        setDirtyInput(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(name);
    }
    function handleFocus() {
        setDirtyInput(true);
    }
    function handleBlur() {
        if (dirtyInput && isInvalid) {
            setLocalValue(value);
            setDirtyInput(false);
            setIsInvalid(false);
        }
    }
    return (_jsxs(_Fragment, { children: [isInvalid && _jsx("span", { className: classes.notification, children: "*" }), _jsx(InlineEditable, { className: clsx(isInvalid && classes.fieldValue__invalid), value: localValue, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, ...props })] }));
}
export function FieldKeyStatic({ children }) {
    return _jsx("span", { className: classes.fieldKey__static, children: children });
}
//# sourceMappingURL=FieldKey.js.map